import * as React from 'react';

const OptimizePerformanceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeWidth="2"
  >
    <path d="M12 7.46a6.07 6.07 0 1 1-3.33 7.91m.89-5.5H3m4.1 2.83H3m10.06-8.53h2.38" />
    <path d="M14.25 7.01V4.55m2.15 7.06l-2.36 1.81" />
  </svg>
);

export default OptimizePerformanceIcon;
